import { IFeature, IFeatureCountryAccountSaveRequest } from '../models/feature';
import { IResult } from '../models/result-models';
import { apiGet, apiPost } from './api-utils';

const baseUrl = process.env.REACT_APP_API_URL + '/v1/feature';

export const getFeatures = async (): Promise<IResult<IFeature[]>> => {
    const result = await apiGet<IFeature[]>(baseUrl);
    return result;
};

export const saveFeatureCountryAccounts = async (
    request: IFeatureCountryAccountSaveRequest
): Promise<IResult<boolean>> => {
    const result = await apiPost<IFeatureCountryAccountSaveRequest, boolean>(
        baseUrl,
        request
    );
    return result;
};
